/* Related parts / Pairs well with from the Product Recommendations API
   (snippets/stoklink-product-related, sections/stoklink-product-recommendations).

   Each [data-recs] placeholder carries its request URL (data-recs-url, with
   section_id, product_id, intent and limit already set) and the product ids
   to leave out (data-recs-exclude: the page's product and its siblings). The
   response is the rendered section wrapped in <div id="shopify-section-…">;
   its [data-recs-rows] > article rows are filtered by data-product-id,
   capped at four and moved into the placeholder, which is then shown. The
   loading note in the same fold is removed and a fold rendered hidden
   ([data-recs-fold]) is shown. No rows left, or a failed request, remove the
   whole fold. Every visible string comes from Liquid. */
(function () {
  'use strict';

  if (!window.fetch || !window.DOMParser) return;

  var MAX_ROWS = 4;

  function excludeMap(value) {
    var map = {};
    String(value || '').split(',').forEach(function (id) {
      id = id.trim();
      if (id) map[id] = true;
    });
    return map;
  }

  function removeFold(box) {
    var fold = box.closest('details.product__fold');
    (fold || box).remove();
  }

  function fill(box) {
    var url = box.getAttribute('data-recs-url');
    if (!url) {
      removeFold(box);
      return;
    }
    var exclude = excludeMap(box.getAttribute('data-recs-exclude'));

    fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rows = doc.querySelectorAll('[data-recs-rows] > article');
        var kept = [];
        Array.prototype.forEach.call(rows, function (row) {
          if (kept.length >= MAX_ROWS) return;
          var id = row.getAttribute('data-product-id') || '';
          if (exclude[id]) return;
          kept.push(row);
        });
        if (!kept.length) {
          removeFold(box);
          return;
        }
        kept.forEach(function (row) {
          box.appendChild(document.importNode(row, true));
        });
        box.hidden = false;

        var fold = box.closest('details.product__fold');
        var scope = fold || box.parentNode || document;
        Array.prototype.forEach.call(scope.querySelectorAll('[data-recs-loading]'), function (note) {
          note.remove();
        });
        if (fold && fold.hasAttribute('data-recs-fold')) fold.hidden = false;

        box.dispatchEvent(new CustomEvent('stoklink:recs', {
          bubbles: true,
          detail: { intent: box.getAttribute('data-recs-intent'), count: kept.length }
        }));
      })
      .catch(function () {
        removeFold(box);
      });
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-recs]'), fill);
})();
